import { render, staticRenderFns } from "./service_type_modal.vue?vue&type=template&id=1c98c3e5&"
import script from "./service_type_modal.vue?vue&type=script&lang=js&"
export * from "./service_type_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports